import { ProjectRenderer } from './ProjectRenderer';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import fileDownload from 'js-file-download';

export enum ExportType {
	GLTF = 'gltf',
}

export class Exporter {
	private gltfExporter = new GLTFExporter();

	constructor(private renderer: ProjectRenderer) {}

	exportCollection(type: ExportType, filename: string) {
		switch (type) {
			case ExportType.GLTF:
				this.exportGLTF(filename);
				break;

			default:
				throw new Error('UNKNOWN_EXPORT_TYPE');
		}
	}

	private exportGLTF(filename: string) {
		this.gltfExporter.parse(
			this.renderer.collection,
			(glb) => {
				fileDownload(glb as ArrayBuffer, filename);
			},
			(error) => {
				console.error('ERROR_EXPORT_GLB:', error);
			},
			{
				binary: true,
			}
		);
	}
}
